import { useSampleApiRequest } from 'modules/campaigns/editor/hooks';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const CodeBox = styled.pre`
  white-space: pre-wrap;
  box-sizing: border-box;
  color: ${colors.textPrimary};
  background-color: #fafafa;
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: 5px;
  padding: 0 ${spacing.plusHalf} ${spacing.base} ${pxToRem(18)};
  max-height: ${pxToRem(282)};
`;

export const SAMPLE_API_REQUEST_TEST_ID = 'sample-api-request';

export const SampleApiRequestCodeBox = () => {
  const { sampleApiRequest } = useSampleApiRequest();

  return <CodeBox data-test={SAMPLE_API_REQUEST_TEST_ID}>{sampleApiRequest}</CodeBox>;
};
